function miles(value) {
  if (value || value === 0) {
    const m = Math.round(value * 10) / 10;
    return `(${m} miles)`;
  }

  return null;
}



export default miles;
